<ng-template #nameControl>
  <div class="form-row">
    <div
      class="col"
      [style.max-width]="selectMaxWidth()">
      <mbs-select
        [appendTo]="appendTo()"
        [bindLabel]="'name'"
        [bindValue]="selectBindValue()"
        [clearable]="false"
        [disabledSelf]="disabled()"
        [id]="selectId()"
        [isAutoWidth]="true"
        [items]="selectOptions()"
        [label]="'wizards:vmName' | i18next"
        [loading]="loading()"
        [ngModel]="selectedSelectValue()"
        [searchable]="false"
        [showRequiredMark]="false"
        [textOverflow]="false"
        (ngModelChange)="machineSelectChangeHandler($event)"></mbs-select>
    </div>

    <div class="col-auto d-flex align-items-end">
      <mbs-button
        icon="fa fa-pencil"
        [container]="'body'"
        [disabled]="disabled()"
        [ngbTooltip]="'wizards:editVMNameTitle' | i18next"
        (click)="openEditModal()"></mbs-button>
    </div>
  </div>
</ng-template>

@if (inline()) {
  <div class="form-row align-items-center">
    <div class="col-6">
      <ng-container [ngTemplateOutlet]="nameControl"></ng-container>
    </div>
    <div class="col-6 pt-2">
      <mbs-switcher
        class="mt-4"
        [disabledSelf]="disabled()"
        [id]="switcherId()"
        [label]="'wizards:destinationOld.destOverwriteVMLabel' | i18next"
        [selected]="overwrite()"
        (change)="overwriteChangeHandler($event)"></mbs-switcher>
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="needOverwriteAlert"></ng-container>
} @else {
  <div class="form-row mb-3">
    <div class="col-12">
      <ng-container [ngTemplateOutlet]="nameControl"></ng-container>
    </div>
  </div>

  <div class="d-flex">
    <mbs-switcher
      [id]="switcherId()"
      [label]="'wizards:destinationOld.destOverwriteVMLabel' | i18next"
      [selected]="overwrite()"
      (change)="overwriteChangeHandler($event)"></mbs-switcher>
  </div>
  <ng-container [ngTemplateOutlet]="needOverwriteAlert"></ng-container>
}

<ng-template #needOverwriteAlert>
  @if (needOverwrite()) {
    <mbs-alert
      class="mb-0 mt-2"
      [attr.data-e2e]="'needOverwrite'"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:needOverwriteAlert' | i18next }}
    </mbs-alert>
  }
</ng-template>

<ng-template #changeNameModal>
  <div>
    <p>{{ 'wizards:editVMNameDescription' | i18next }}</p>
    <mbs-input
      name="restoreAsName"
      [id]="'vm-settings-vm-name-input'"
      [label]="'wizards:editVMNameLabel' | i18next"
      [validationWhitespace]="true"
      [value]="editNameValue()"
      (blur)="editNameTouched.set(true)"
      (change)="editNameChangeHandler($event)"></mbs-input>
    <mbs-input-errors [errors]="editNameErrors()"></mbs-input-errors>
  </div>
</ng-template>
